// extracted by mini-css-extract-plugin
export default {"cookieContainer":"Cookie_cookieContainer__e3r1A","cookie":"Cookie_cookie__D6zcP"};